import { validators, z } from '../utils';
import { makeFormHook } from '../utils/factory';
import type { InferFormType } from '../utils/types';

const ssoProfileFormSchema = z.object({
  firstName: validators.requiredString('First name'),
  lastName: validators.requiredString('Last name'),
});

export type SSOProfileFormSchema = InferFormType<typeof ssoProfileFormSchema>;

export const ssoProfileFormDefaultValues: SSOProfileFormSchema = {
  firstName: '',
  lastName: '',
};

export const useSSOProfileForm = makeFormHook(ssoProfileFormSchema, ssoProfileFormDefaultValues);
